<template>
  <a-modal v-model:visible="visible" title="请打开【淘特APP】扫码授权" :maskClosable="false" width="450px">
    <div class="box" v-if="params.QrCodeUrl">
      <div style="text-align: left;">
        <span class='tip'>温馨提示：使用淘特铺货功能时，必须要先授权淘特</span><br>
        <span v-show="params.TipMsg" class='tip'>{{ params.TipMsg }}</span>
        <div v-if="params.TipMsg" style="text-align:left">
          <a-tooltip placement="top">
            <template #title>
              <span style="font-size: 15px">如需要换成其他淘特账号授权, 则点击[解除绑定]按钮后, 再扫码授权即可</span>
            </template>
            <a-button type="primary" danger style="margin-top: .4em" :loading="loading" @click="unbindTaoteAuth">解除绑定</a-button>
          </a-tooltip>
        </div>
      </div>
      <vue-qr :size="260" :text="params.QrCodeUrl" />
      <div style="text-align: left;">
        <span class='tip'>如已确认完成扫码授权，请点击【已确认完成授权】按钮</span>
      </div>
    </div>
    <template #footer>
      <a-button type="primary" :loading="loading" @click="finishAuth">已确认完成授权</a-button>
    </template>  
  </a-modal>
</template>
<script>
import VueQr from 'vue-qr/src/packages/vue-qr.vue'
import api from './api'
export default {
  components: { VueQr },
  data() {
    return {
      visible: false,
      loading: false,
      params: {}
    }
  },
  methods: {
    async finishAuth() {
      this.loading = true
      const { success, msg } = await api.TaoteAuth({ code: this.params.Code })
      this.loading = false
      if (!success) return this.$message.warning(msg)
      this.$message.success('已完成淘特授权！')
      this.$emit('success')
      this.visible = false
    },
    async unbindTaoteAuth() {
      this.loading = true
      const { success, msg } = await api.UnbindAccount('taote')
      this.loading = false
      const str = '解绑淘特授权账号'
      if (!success) return this.$message.warning(`${str}，原因:【${msg}】`)
      this.params.TipMsg = ''
      this.$message.success(`${str}成功`)
    }
  },
  watch: {
    visible(value) {
      if (!value) {
        this.params =  {}
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .box {
    text-align: center;
    .tip {
      font-weight: bold;
      color: red;
      font-size: 16px;
    }
  }
</style>